// extracted by mini-css-extract-plugin
export default {"pieContainer":"Pie_pieContainer__4Gf46","pieLogo":"Pie_pieLogo__Krvvx","pieInfo":"Pie_pieInfo__19nfz","pieSocial":"Pie_pieSocial__Opd2v","pieTexto":"Pie_pieTexto__Qzq+A"};